import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { BatchingRules } from '@types-lib';
import { ENVIRONMENT, PIMSEnvironment } from 'environments';

export class BatchingRulesIdEndpoints {
  private env = inject<PIMSEnvironment>(ENVIRONMENT);
  private http = inject(HttpClient);

  // Update rule
  put(id: number, body: BatchingRules.UpdateBatchingRuleRequest) {
    const url = `${this.env.constants.ADMIN_API_URL}/admin/batches/rules/${id}`;
    return this.http.put<void>(url, body);
  }

  // Delete rule
  delete(id: number) {
    const url = `${this.env.constants.ADMIN_API_URL}/admin/batches/rules/${id}`;
    return this.http.delete<void>(url);
  }
}
